import "styles/buttonFooter.less";
import { FC, useContext } from "react";

import { AppContext } from "App";
import { useNavigate } from "react-router-dom";
import useDetectKeyboardOpen from "use-detect-keyboard-open";

interface ButtonFooterProps {
    showButtonFooter: boolean;
}

const ButtonFooter: FC<ButtonFooterProps> = ({ showButtonFooter = true }) => {
    const navigate = useNavigate();
    const { isMobile, isAuth } = useContext(AppContext);
    const isKeyboardOpen = useDetectKeyboardOpen();

    if (!isMobile || isKeyboardOpen) return null;

    return (
        <div className={`button-footer ${showButtonFooter ? "visible" : ""}`}>
            {isAuth
                ? <button className="shared__primary-button wAuto" onClick={() => navigate("/profile")}>Profile</button>
                : <>
                    <button className="shared__primary-button wAuto" onClick={() => navigate("/sign-up?step=personalInfo")}>Sign Up</button>
                    <div className="button-footer-or">OR</div>
                    <button
                        className="shared__secondary-button wAuto"
                        onClick={() => {
                            navigate("/auth");
                        }}
                    >
                        Login
                    </button>
                </>
            }
        </div>
    );
};

export default ButtonFooter;
